import { Popover } from 'antd';
import { Interweave } from 'interweave';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Icon } from 'ui';

export const StyledInfoIcon = styled(Icon)`
  margin-left: 5px;
`;

const InfoTooltip = ({
  title = '',
  content = '',
  placement = 'bottomLeft',
  width = '450px',
  popupContainer,
  zIndex = 9999,
  children = null,
}) => {
  if (!content && !title) {
    return null;
  }

  return (
    <Popover
      placement={placement}
      title={title}
      content={<Interweave content={content} />}
      overlayStyle={{ width, zIndex }}
      getPopupContainer={
        popupContainer ||
        (() => document.getElementsByClassName('fullscreen') ?
          document.getElementsByClassName('fullscreen')[0] :
          document.body
        )
      }
    >
      {children || <span>
        <StyledInfoIcon type='info-circle' onClick={e => e.preventDefault()} />
      </span>}
    </Popover>
  );
};

InfoTooltip.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  placement: PropTypes.string,
  width: PropTypes.string,
  popupContainer: PropTypes.func,
  zIndex: PropTypes.number,
  children: PropTypes.node,
};

export default InfoTooltip;
